import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';

export const ingestCPL = createAsyncThunk('content/ingestCPL', async (cpl, { rejectWithValue }) => {
    try {
        const response = await api.post(`/content/${cpl._id}`, cpl);
        return response.data;
    } catch (error) {
        const errorData = error.response?.data || { message: 'Failed to ingest content' };
        return rejectWithValue(errorData);
    }
});

export const markContentDeleted = createAsyncThunk('content/markDeleted', async (contentId, { rejectWithValue }) => {
    try {
        const response = await api.post(`/content/${contentId}/mark-deleted`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || { message: error.message });
    }
});

// Clears a Mediablock removal request the cleanup job will never finish; the server refuses (409)
// anything still in flight, and its message is what the toast shows.
export const restoreContent = createAsyncThunk('content/restore', async (contentId, { rejectWithValue }) => {
    try {
        const response = await api.post(`/content/${contentId}/restore`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || { message: error.message });
    }
});

export const fetchOrderKDM = createAsyncThunk('content/fetchOrderKDM', async ({ uuid, organization }) => {
    const response = await api.get('/content/kdm', { params: { uuid, organization } });
    return response.data?.kdm || null;
});

const contentSlice = createSlice({
    name: 'user',
    initialState: {
        current: null,
        status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(ingestCPL.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ingestCPL.fulfilled, (state, action) => {
                state.status = 'success';
                state.current = action.payload;
            })
            .addCase(ingestCPL.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload?.message || 'An error occurred';
            })
    },
});

export default contentSlice.reducer;
